export const MAX_REVIEW_STARS = 5;
export const RATING_STARS_VALUES = ['', '1', '2', '3', '4', '5'];
export const PAGE_SIZE = 10;
export const DELETE_REFETCH_ATTEMPTS = 3;
export const DELETE_REFETCH_RETRY_DELAY_MS = 300;
